module.exports = __webpack_public_path__ + "static/rappi-1-014f4a1ca6cfa78cee3d07d55c4a243a.jpg";